import { useBooleanFlagValue } from "@openfeature/react-sdk";
import flags from "../features/featureFlags/flags";
import { useSelector } from "react-redux";
import { selectIsMobileApp } from "../store/reducers/runtimeDetails";
import useScreenSize from "./useScreenSize";

const useAppModernisation = () => {
  const { isDesktop } = useScreenSize();
  const isAppModernisationEnabled = useBooleanFlagValue(
    flags.APP_MODERNISATION,
    false,
  );
  const isWebModernisationEnabled = useBooleanFlagValue(
    flags.WEB_MODERNISATION,
    false,
  );
  const isCalculatorsLegacyIntegration = useBooleanFlagValue(
    flags.CALCULATORS_LEGACY_INTEGRATION,
    false,
  );
  const isMobileApp = useSelector(selectIsMobileApp);
  const isForceAppMode = useBooleanFlagValue(flags.FORCE_APP_MODE, false);
  const isEnhancedSearchEnabled = useBooleanFlagValue(
    flags.ENHANCED_SEARCH,
    false,
  );
  const isAppMode =
    isAppModernisationEnabled && (isMobileApp || isForceAppMode);
  const isEnhancedCounter = useBooleanFlagValue(flags.ENHANCED_COUNTER, false);

  const isMobileView = isAppMode || (isWebModernisationEnabled && !isDesktop);

  const isModernView = isAppMode || isWebModernisationEnabled;

  return {
    
    isAppMode, 
   
    isWebModernisationEnabled, 
    isCalculatorsLegacyIntegration,
   
    isEnhancedSearchEnabled, 
   
    isEnhancedCounter,
    isMobileView,
    isModernView,
  
  };
};

export default useAppModernisation;
